export default class teamService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/team',
			"id": '/api/team/:id',
			"new": '/api/team',
			'delete': '/api/team/:id',
            "update": '/api/team',
            "availableUsers": '/api/team/available/users',
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

    update(data){
        let url = this.baseUrl + this.routes.new;
        return this.http.put(url, data);
    }

    delete(objId){
        let idRoute = this.routes.delete.replace(':id', objId._id);
        let url = this.baseUrl + idRoute;
        return this.http.delete(url);
    }

    getAvailableUsers(filter){
        let url = this.baseUrl + this.routes.availableUsers;
        let config = {
            params : filter
        };
        return this.http.get(url, config);
    }
}



// WEBPACK FOOTER //
// ./app/js/services/teamService.js